import React, { ChangeEvent, ReactNode, useState } from "react";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import { Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, IconButton, LinearProgress, MenuItem, Link as MuiLink, Select, Tooltip, useTheme } from "@material-ui/core/";
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  useExpanded,
} from "react-table";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import { getNoteType } from "../../../../util/searchData";
import { ViewActiveNoteList } from "../../../common/ViewActiveNotes";
import { ThreadedCreator } from "../../../common/threadedViewer/threadedCreator";

import { dispositionProjectUpdate, useAddNoteToProject } from "../../projectManagementMutations";
import { useProjectNotes } from "../../projectQueries";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { renderHeader } from "../../../common/util";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { ViewAddNoteList } from "../../../common/ViewAddNotes";
import { type } from "@testing-library/user-event/dist/type";
import { CloudDownload, Edit } from "@material-ui/icons";
import { EditProjects } from "../../../common/EditProjects";
import { useDispositions } from "../../../common/services/dispositionServices";
import { toast } from "react-toastify";
import { getTheme } from "../../../common/getLocalTheme";
import { formatDate } from "../../../common/formatDate";
import { CalibrationTable } from "./calibrationTable";
import { CalibrationPage } from "./calibrationPage";
import { AssetManagementEdit } from "./assetManagementEdit";
import ScreenWidth from "../../../common/ScreenWidth";
import { useFetchContext } from "../../../common/FetchContext";
import { useAssetsDispositionUpdate, useLastActionAssetData } from "../../../intake/intakeQueries";
import CloseIcon from '@material-ui/icons/Close';
import { ListSubAsset } from "./ListSubAsset";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { AssetHistoryView } from "./AssetHistoryView";



export const RevokeTable = ({ assets, assetDisposition }: any) => {
  const history = useHistory();
  const { authAxios } = useFetchContext();
  const { path } = useRouteMatch();
  const count = 0;
  const theme = useTheme();
  const defaultColumn = useDefaultColumn();
  const widthCurrent = ScreenWidth();
  const { mutateAsync: mutateAddNote } = useAddNoteToProject();
  const [open, setOpen] = React.useState(true);
  const { mutateAsync: mutate } = dispositionProjectUpdate();
  const { mutateAsync: mutateDispositionUpdate } = useAssetsDispositionUpdate();
  const [selectedAssetId, setSelectedAssetId] = useState<string | null>(null);
  const [actionDialog, setActionDialog] = useState(false);

  const { data: lastActionData, isLoading: isActionLoading } = useLastActionAssetData(selectedAssetId ?? "");

  const handleActionDialogClose = () => {
    setActionDialog(false);
    setSelectedAssetId(null);
  }


  const handleDownload = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Extract the data from the button's dataset
    const reportData = event.currentTarget.getAttribute("data-report");

    if (reportData) {
      const parsedData = JSON.parse(reportData);
      const downloadUrl = parsedData.azurefile_download; // Extract download URL

      if (downloadUrl) {
        // window.open(downloadUrl, "_blank"); // Open in a new tab
        // OR trigger a download
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "file_name.ext"); // Set desired file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("Download URL not found");
      }
    } else {
      toast.success("No report data found", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };


  const columns = React.useMemo(
    () => [


      {
        Header: () => null, // No header
        id: "expander", // It needs an ID
        Cell: ({ row }: any) => (
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? (
              <KeyboardArrowDownIcon />
            ) : (
              <KeyboardArrowUpIcon />
            )}
          </span>
        ),
      }, {
        Header: "ID",
        accessor: "id"

      },
      {
        id: "Asset ID",
        accessor: "asset_number",
        filter: generalFilter,
        Cell: ({ cell, row }: any) => {
          const assetId = row.original.id
          return <Button
            style={{ textAlign: "left", justifyContent: "flex-start", }}
            color="primary"
            fullWidth={true}
            onClick={() => {
              history.push(`asset_management/${assetId}/`);

            }}

          >
            {cell.value}
            <Edit />
          </Button>
        },
      },
      {
        id: "Asset Name",
        accessor: "asset_name",
        filter: generalFilter,
        Cell: ({ cell, row }: any) => {
          const { is_main_asset, id: assetId, in_use } = row.original;
          const [viewDialogOpen, setViewDialogOpen] = useState(false);



          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minWidth: "250px",
              }}
            >

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <span style={{ fontSize: "14px" }}>{cell.value}</span>

                <Tooltip title="View">
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => {

                      setViewDialogOpen(true);
                    }}
                  >
                    <VisibilityIcon style={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>

              </div>


              {is_main_asset && (
                <div
                  style={{
                    backgroundColor: "#FFF6E5",
                    padding: "4px 6px",
                    border: "1px solid #FFD27F",
                    borderRadius: "50px",
                    fontSize: "10px",
                    color: "#FFA500",
                    marginTop: "6px",
                    lineHeight: 1,
                    display: "inline-block",
                  }}
                >
                  Primary Asset
                </div>
              )}


              <Dialog
                open={viewDialogOpen}
                onClose={() => setViewDialogOpen(false)}
                fullWidth
                maxWidth="xl"
              >
                <DialogTitle>
                  <Grid container justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Asset Details</Typography>
                    <IconButton onClick={() => setViewDialogOpen(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </DialogTitle>

                <Divider />

                <DialogContent dividers>
                  <AssetHistoryView assetID={assetId} />
                </DialogContent>

                <DialogActions>
                  <Button
                    onClick={() => setViewDialogOpen(false)}
                    color="secondary"
                    variant="outlined"
                  >
                    Close
                  </Button>
                </DialogActions>
              </Dialog>

            </div>
          );
        },
        width: 350,
        minWidth: 300,
        maxWidth: 400,
      },


      {
        id: "Asset Type",
        accessor: "asset_type_name",
        filter: generalFilter,
        width: 250,
        minWidth: 200,
        maxWidth: 250,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Description",
        accessor: "description",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Disposition",
        accessor: "disposition",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ row }: any) => {
          const assetId = row.original.id;


          const handleChange = async (e: any) => {
            var newDisposition = e.target.value as string
            await mutateDispositionUpdate({
              authAxios,
              id: assetId,
              disposition: newDisposition,
            });
            toast.success("Asset disposition status updated successfully");

          }


          return (
            <Select
              labelId="disposition_select"
              id="disposition_select"
              disableUnderline
              defaultValue={row.original.disposition}
              label="Disposition"
              disabled={getTheme() || row.original.in_use}
              onChange={handleChange}
            >
              {assetDisposition?.map((disposition: any) => (
                <MenuItem key={disposition.id}
                  value={disposition.url}>
                  {disposition.name}
                </MenuItem>
              ))}
            </Select>
          );
        },
      },
      {
        id: "Last Action",
        accessor: "last_action_datetime",
        Cell: ({ cell, row }: any) => {
          if (!cell.value) {
            return <Typography>N/A</Typography>;
          }
          return (
            <MuiLink
              onClick={() => {
                setSelectedAssetId(row.original.id);
                setActionDialog(true);
              }}
              style={{ cursor: "pointer" }}
            >
              {formatDate(cell.value)}
            </MuiLink>
          );
        },
        width: 350,
        minWidth: 300,
        maxWidth: 400,
      },

      {
        id: "Loaction",
        accessor: "location_name",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Manufacturer",
        accessor: "manufacturer",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        id: "Model",
        accessor: "model",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },

      {
        id: "Serial Number",
        accessor: "serial_number",
        filter: generalFilter,
        width: 300,
        minWidth: 250,
        maxWidth: 400,
        Cell: ({ cell }: any) => (
          <Typography>
            {cell.value ? cell.value : "N/A"}
          </Typography>
        ),
      },
      {
        Header: "Download", // No header
        id: "azurefile_download",
        Cell: ({ row }: any) => (
          <div>
            <Button
              color="primary"
              onClick={handleDownload}
              startIcon={<CloudDownload />}
              data-report={JSON.stringify(assets[row.index])}
            />
          </div>
        ),
      }
    ],
    []
  );





  const { getTableProps, visibleColumns, headerGroups, rows, prepareRow } =
    useTable(
      {
        data: assets,
        columns,
        defaultColumn,
        initialState: {
          hiddenColumns: ["id"],

        },
      },
      useFilters,
      useGlobalFilter,
      useSortBy,
      useExpanded
    );



  return (
    <>

      <TableContainer
        data-testid="tableContainer"
        style={{
          ...theme.tableContainer,
          maxHeight: "1000px",
          overflowX: 'auto',
          overflowY: 'auto',
          whiteSpace: 'nowrap',
          maxWidth: `${widthCurrent}px`
        }}
        component={Paper}
      >
        <MuiTable stickyHeader {...getTableProps()} size="small">
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps()}
                    style={{ minWidth: column.minWidth, width: column.width, maxWidth: column.maxWidth }}
                  >
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={0}
                    >
                      <Grid item xs={12} {...column.getHeaderProps()}>
                        <Grid
                          container
                          direction="row"
                          alignItems="center"
                          spacing={0}
                        >
                          <Typography variant="subtitle2">
                            {(column.id === "Intake Directives" ||
                              column.id === "Notes" ||
                              column.id === "Add Tasks") &&
                              column.render("Header")}
                          </Typography>
                          {column.canFilter ? column.render("Filter") : null}
                          <Grid item xs={2}>
                            {/* <IconButton
                                type="submit"
                                aria-label="search"
                                size="small"
                                {...column.getSortByToggleProps()}
                              >
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <ArrowDropDownIcon />
                                  ) : (
                                    <ArrowDropUpIcon />
                                  )
                                ) : (
                                  column.id !== "expander" &&
                                  column.id !== "Intake Directives" &&
                                  column.id !== "Notes" &&
                                  column.id !== "Add Tasks" && <CallSplitIcon />
                                )}
                              </IconButton> */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <>
                  <TableRow {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <TableCell {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </TableCell>
                      );
                    })}
                  </TableRow>

                  {row.isExpanded ? (
                    <TableRow>
                      <TableCell colSpan={visibleColumns.length}>
                        <CalibrationPage id={row.values.id} />
                      </TableCell>
                    </TableRow>
                  ) : null}
                </>
              );
            })}
          </TableBody>
        </MuiTable>
      </TableContainer>
      <Dialog
        open={actionDialog}
        onClose={handleActionDialogClose}
        aria-labelledby="dialog-title"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Last Action Info</Typography>
            <IconButton onClick={handleActionDialogClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>

        <Divider />

        <DialogContent dividers>
          {isActionLoading ? (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : lastActionData ? (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">Asset Name:{lastActionData.asset_name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>Action: {lastActionData.action_name}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>User: {lastActionData.username}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography>Action Time: {formatDate(lastActionData.action_datetime)}</Typography>
              </Grid>

            </Grid>
          ) : (
            <Typography>No action data available.</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleActionDialogClose}
            color="secondary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>



    </>


  );



};

